// import uuid from 'uuid/v1';
import msg from '../message/index';
import { encodeWindowName, decodeWindowName } from '../childWindowName';
import { logPR } from '../util';

const { version } = require('../../package.json');

let instance = null;

const init = (platform:any = {}) => {
    const children = {};
    const store = [];

    const entry = (e:any) => {
        // const ret = store.find(ele => e.data && (e.data.type === ele.type));
        if (e.data && msg.has(e.data.$type)) {
            logPR(`receive ${e.data && e.data.$type || '未知类型消息'}, 已分发处理`);
        } else {
            logPR(`receive ${e.data && e.data.$type || '未知类型消息'}, 但是未处理`, e.data, e);
        }
    };

    window.addEventListener('message', entry);

    store.push(msg.on('PR:platformConnect', ({ $windowName }, e, reply) => {
        if ($windowName) {
            children[$windowName] = e.source;
        }

        reply({
            platformType: platform.type,
            partnerVersion: version
        });
    }));

    instance = {
        getChildren() {
            return children;
        },
        close() {
            window.removeEventListener('message', entry);
            store.forEach(ele => ele.off());
            instance = null;
        },

        getIframeCode: (windowName) =>
            decodeWindowName(windowName, (_, iframeCode) => iframeCode, () => windowName),

        /**
         * 根据 iframeCode 生成 windowName
         */
        SMPIframe: (iframeCode) => encodeWindowName(platform.type, iframeCode),

        /**
         * 作为 Vue 插件
         * @param Vue
         */
        install(Vue) {
            Vue.$platformPeceptions = this;
            Vue.prototype.$platformPeceptions = this;

            Vue.filter('SMPIframe', (iframeCode) => this.SMPIframe(iframeCode));
        }
    };
    return instance;
}

export default (platform:any) => {
    logPR('我是菜单伴侣主页面平台接待, 负责处理来自子页面的通用通讯事件');
    logPR(`SMP version: ${version}`);
    return instance || init(platform);
};
